module.exports = __webpack_public_path__ + "assets/cart-b57267.svg";